import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b7918e62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "detail-item" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = { class: "detail-item" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "detail-item" }
const _hoisted_7 = { style: {"margin-left":"20px"} }
const _hoisted_8 = { class: "flex" }
const _hoisted_9 = { class: "detail-item" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "detail-item" }

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { getJapanTime } from '@/util/common'
import { formatPrice, plusPrice, reducePrice, platformOrderItemSettleTypeDict } from '../data_old'

export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  },
  rowName: {
    type: String,
    default: ''
  },
  rowItemDetail: {
    type: Object,
    default: () => ({})
  },
  type: {
    type: Number,
    default: 1
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createBlock(_component_el_scrollbar, { height: "500px" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('销售额取值范围')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.salesAmountGetStartTime) + "-" + _toDisplayString(__props.rowItemDetail.salesAmountGetEndTime), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('返现类型')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.backMoneyType === 1 ? _unref(t)('返现') : ''), 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.backMoneyType === 2 ? _unref(t)('销售额X%') : ''), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", _hoisted_6, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('月销售额区间')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.sectionStartValue) + "-" + _toDisplayString(__props.rowItemDetail.sectionEndValue), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.rowItemDetail.backMoneyType === 1 ? _unref(t)('返现2') : _unref(t)('返点')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.commission) + _toDisplayString(__props.rowItemDetail.backMoneyType === 1 ? '元' : '%'), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('活动有效期')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.expirationStartDate) + "-" + _toDisplayString(__props.rowItemDetail.expirationEndDate), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("p", _hoisted_11, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('返现发放时间')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.timeCalculateType === 1 ? _unref(t)('每月X日自动返').replace('X', __props.rowItemDetail.calculateDay) : ''), 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.timeCalculateType === 2 ? _unref(t)('每季度自动返') : ''), 1),
            _createElementVNode("span", null, _toDisplayString(__props.rowItemDetail.timeCalculateType === 3 ? _unref(t)('每半年自动返') : ''), 1)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})